import { employeeAttributeActions } from '~/behaviors/actions/employee_attribute.actions';
import { useAppDispatch } from '~/behaviors';

// Exported for testing
export const fetchEmployeeAttributesIfNeeded = ({
  companyId,
  dispatch,
}: {
  companyId?: number;
  dispatch: ReturnType<typeof useAppDispatch>;
}) => {
  if (companyId) {
    dispatch(
      employeeAttributeActions.fetchEmployeeAttributes({
        companyId,
        includePrivateAttributes: false,
      }),
    );
  }
};
